import { useMemo } from 'react';

import type { AnchorableAttrs } from '../nodes/types';

export const useAnchorable = (attrs?: AnchorableAttrs) => {
  const isAnchor = useMemo(() => {
    return attrs?.anchorEnabled && !!attrs?.anchorId;
  }, [attrs?.anchorEnabled, attrs?.anchorId]);

  const anchorId = useMemo(() => {
    return attrs?.anchorId || undefined;
  }, [attrs?.anchorId]);

  const anchorAttributes = useMemo(() => {
    if (!isAnchor) {
      return {};
    }

    return { id: anchorId };
  }, [isAnchor, anchorId]);

  return {
    anchorAttributes,
  };
};
